module.exports = __webpack_public_path__ + "static/media/box.d1f0c698.svg";